import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Frac, KPIDashboardService } from '~lmo/kpidashboard/kpidashboard.service';
import { trackById } from '~utilities/trackById';

@Component({
  selector: 'sa-frac-selector',
  styleUrls: ['./frac-selector.component.scss'],
  templateUrl: './frac-selector.component.html',
})
export class FracSelectorComponent implements OnInit {
  public fracs: Frac[] = [];
  public selectedFracIds: (number | string)[] = [];
  public shouldHide = true;
  public showAllFracs = true;

  constructor(private kpiDashboardService: KPIDashboardService, private activatedRoute: ActivatedRoute) {}

  public readonly trackById = trackById;

  public ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      const fracId = params['frac_id'] ? +params['frac_id'] : null;
      if (fracId !== null) {
        this.selectedFracIds = [fracId];
      }
    });

    this.kpiDashboardService.regionID$.subscribe((regionID: number | string) => {
      if (regionID && regionID !== 'all') {
        if (typeof regionID === 'number') {
          this.fetchFracsList(regionID);
        }
      } else {
        this.fracs = [];
        this.shouldHide = true;
        this.selectedFracIds = [];
      }
    });
  }

  private fetchFracsList(regionID: number): void {
    this.kpiDashboardService.getFracs$(regionID).subscribe((data) => {
      this.fracs = data;
      this.shouldHide = false;

      const localFracID = this.kpiDashboardService.getLocalStorage('frac_id') ?? ['all'];
      this.kpiDashboardService.setFracsID(localFracID);

      this.selectedFracIds = localFracID ?? ['all'];
    });
  }

  public onSelectionChange(selectedIds: (number | string)[]): void {
    if (this.selectedFracIds.includes('all') && this.showAllFracs) {
      this.selectedFracIds = selectedIds.filter((id) => id !== 'all');
      this.kpiDashboardService.setFracsID(this.selectedFracIds as number[]);
      this.showAllFracs = false;
    } else if ((selectedIds.includes('all') && !this.showAllFracs) || selectedIds.length === 0) {
      this.selectedFracIds = ['all'];
      this.showAllFracs = true;
      this.kpiDashboardService.setFracsID([null]);
    } else {
      this.kpiDashboardService.setFracsID(selectedIds as number[]);
    }

    this.kpiDashboardService.setLocalStorage('frac_id', this.selectedFracIds);
  }
}
